import axios from './http';
import login from './module/login';
import screen from './module/screen';
import market from './module/market';
import common from './module/common';
import member from './module/member';
import sso from './module/sso';

const api = {
  // moduleName
  login,
  screen,
  market,
  common,
  member,
  sso
};

/** 遍历api处理接口 */
Object.keys(api).forEach((module) => {
  let arr = api[module];

  let moduleDict = {};

  arr.forEach((item) => {
    let { name, url, method, defaultParams, defaultConfig } = item;
    method = (method || 'GET').toLowerCase();

    /**
     * @param {object} params api参数对象，也可以传数组
     * @param {array} pathParams api路径参数，比如配置接口：'/api/aam/v1/mgmt/role-hierachy/{@}/roles/{@}/resources'，需要传入['a', 'b']来替换两个{@}
     * @param {object} config 其他配置项，同axios官方配置config
     * @usage 使用：在Vue组件中直接使用 this.$api.moduleName.apiFunction(params, pathParams, config).then(res => {})
     */
    moduleDict[name] = (params = {}, pathParams = [], config = {}) => {
      let isArray = Array.isArray(params);
      let isFormData = params instanceof FormData;
      if (!isFormData && !isArray && defaultParams) {
        params = Object.assign({}, defaultParams, params);
      }
      if (defaultConfig) {
        config = Object.assign({}, defaultConfig, config);
      }
      // 拷贝一个url
      let _url = url;
      // 替换url中path的'{@}'
      if (_url.includes('{@}') && Array.isArray(pathParams)) {
        let urlStrList = _url.split('{@}');
        _url = '';
        urlStrList.forEach((str, index) => {
          _url += str;
          if (!isNaN(pathParams[index]) || pathParams[index] === 0) {
            _url += pathParams[index];
          } else {
            pathParams[index] && (_url += pathParams[index]);
          }
        });
      }
      if (method === 'put' && !config?.bodyParams) {
        let paramsStr = '';
        for (let key in params) {
          paramsStr += `&${key}=${params[key]}`;
        }
        if (paramsStr[0] === '&') {
          paramsStr = paramsStr.slice(1, paramsStr.length);
        }
        _url += '?' + paramsStr;
        params = {};
      }
      return axios[method](_url, params, config);
    };
  });

  api[module] = moduleDict;
});

console.log('api => ', api);

api.$axios = axios;

/** api直接挂载在Vue.prototype上面 */
export default api;
